import React, { useEffect, useState } from "react";
import { HelpPopout } from "./HelpPopout";
import { Calendar, ConfigProvider, Space, Switch, DatePicker, Spin } from "antd";
import infoImage from "../../../Images/info-icon.svg";
import en_GB from "antd/lib/locale-provider/en_GB";
import "../../../Styles/styles-Calendar.css";
import { DateCellContent } from "./DateCellContent";
import { DateCellTooltip } from "./DateCellTooltip";
import { useSelector } from "react-redux";
import {
  getDateString,
  getPredictionInfo,
} from "../../../Utils/calendar_utils";
import AddPredictionDialog from "../AddPredictionDialog";
import moment from "moment";
import { trainingAPI } from "../../../api/TrainingAPI";
import { DateInfoPopout } from "./DateInfoPopout";
import { getYearDataV2 } from "../../../store/actions/calendar.actions";
import { useDispatch } from "react-redux";
import { audioMessage as message } from "../../Common/Notifications/audioMessage";

export const CalendarView = ({ loading, setLoading}) => {
  const dispatch = useDispatch();
  const { data, metrics } = useSelector(({ calendar }) => calendar);
  const [showHelp, setShowHelp] = useState(false);
  const [showGameAndTraining, setShowGameAndTraining] = useState(false);
  const [showDateInfoPopout, setShowDateInfoPopout] = useState(false);
  const [showPredictionDialog, setShowPredictionDialog] = useState(false);
  const [predictionDialogDate, setPredictionDialogDate] = useState(null);
  const [dateInfo, setDateInfo] = useState({});
  const [forceOpenDate, setForceOpenDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(moment());
  

  const { costPerMin, drills } = useSelector(({ team }) => team);

  useEffect(() => {
    if (forceOpenDate) {
      clickFuture(forceOpenDate, false);
      setForceOpenDate(null);
    }
  }, [forceOpenDate]);

  const openPredictionDialog = (date) => {
    setPredictionDialogDate(date);
    setShowPredictionDialog(true);
  };

  const openDateInfoPopout = (info) => {
    setDateInfo(info);
    setShowDateInfoPopout(true);
  };

  const clickFuture = async (value, autoOpenAddPlan = true) => {
    const dateString = moment(value).format("YYYY-MM-DD");
    const practicePlan = await trainingAPI.getPracticePlan(
      dateString,
      dateString
    );
    if (practicePlan && practicePlan.length !== 0) {
      const predictionInfo = getPredictionInfo({
        costPerMin,
        data,
        metrics,
        drills,
        dateString,
        practicePlan,
      });
      openDateInfoPopout(predictionInfo);
    } else if (autoOpenAddPlan) {
      openPredictionDialog(dateString);
    }
  };

  const isFutureDate = (date) => {
    const dateString = moment(date).format("YYYY-MM-DD");
    const todayString = moment().format("YYYY-MM-DD");
    return (
      dateString > todayString ||
      (dateString === todayString && data[dateString].total_time === undefined 
        )
    );
  };

  const handleClickDateCell = (date) => {
    if (isFutureDate(date)) {
      clickFuture(date);
    } else {
      openDateInfoPopout(data[getDateString(date)]);
    }
  };

  const dateCellRender = (value) => {
    return (
      <DateCellContent
        date={value}
        info={data[getDateString(value)]}
        onClick={() => {
          handleClickDateCell(value);
        }}
        showGameAndTraining={showGameAndTraining}
      />
    );
  };

  const handleDateChange = (date) => {
    // Check if the month or year of the new date is different from that of the previously selectedDate
    if (selectedDate && (date.month() === selectedDate.month()) && (date.year() === selectedDate.year())) {
      return;
    }

    setLoading(true);
    let start_date = date.startOf('month').format('MM/DD/YYYY');
    let end_date = date.endOf('month').format('MM/DD/YYYY');
    dispatch(getYearDataV2(start_date, end_date, setLoading));
  };

  const headerRender = ({onChange}) => {
    return (
      <DatePicker
        value={selectedDate}
        format='YYYY/MM'
        picker="month"
        onChange={(date) => {
          setSelectedDate(date);
          onChange(date);
        }}
        allowClear={false}
        className="calender_yearmonth_picker"
      />
    );
  };

  const handleDeletePracticePlan = async () => {
    const { date } = dateInfo;
    const monthStart = moment(date, "YYYY-MM-DD").startOf('month').format('MM/DD/YYYY');
    const monthEnd = moment(date, "YYYY-MM-DD").endOf('month').format('MM/DD/YYYY');
    try {
      dispatch(getYearDataV2(monthStart, monthEnd, setLoading));
      setShowDateInfoPopout(false);
      await trainingAPI.deletePracticePlanByDate(date)
      await clickFuture(date);
    } catch(error) {
      setLoading(false);
      console.error("Error deleting practice plan ", error, date)
      message.error("Error deleting practice plan")
    }
    message.success(`Predictions deleted for date ${date}`);
  }

  return (
    <>
      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
        <DateInfoPopout
          showInfoPopout={showDateInfoPopout}
          setShowInfoPopout={setShowDateInfoPopout}
          info={dateInfo}
          metrics={metrics}
          openPredictionDialog={openPredictionDialog}
          handleDeletePracticePlan={handleDeletePracticePlan}
          showHelp={() => {setShowHelp(true)}}
        />
        <HelpPopout showPopout={showHelp} setShowPopout={setShowHelp} />
      </div>
      <div className="calender-view-container">
        {/* Toggling between showing game/training or score */}
        <Switch
          checkedChildren="G/T"
          unCheckedChildren="Score"
          defaultChecked={!showGameAndTraining}
          onChange={() => setShowGameAndTraining(!showGameAndTraining)}
        />

        <img
          src={infoImage}
          alt="info-img"
          style={{ cursor: "pointer", width: "20px", height: "20px" }}
          onClick={() => setShowHelp(true)}
        />
      </div>
      <Space>
        <ConfigProvider locale={en_GB}>
          <Spin spinning={loading}>
            <Calendar 
              onChange={(date) => {
                handleDateChange(date);
                setSelectedDate(date);
              }}
              // value={selectedDate}
              dateCellRender={dateCellRender} 
              headerRender={headerRender}
              className="calender" 
            />
          </Spin>
        </ConfigProvider>
      </Space>
      <AddPredictionDialog
        open={showPredictionDialog}
        setOpen={setShowPredictionDialog}
        date_string={predictionDialogDate}
        drills={drills}
        refreshPopup={setForceOpenDate}
      />
    </>
  );
};
